import { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'
import { statusToVariant, variantStyles } from '../constants'
import type { ContractorStepDetailsCardStatus } from '../types'

export interface ContractorStepDetailsStatusLabelProps {
  label: string
  status: ContractorStepDetailsCardStatus
  isDeclined: boolean
}

const ContractorStepDetailsStatusLabelComponent = ({
  label,
  status,
  isDeclined,
}: ContractorStepDetailsStatusLabelProps) => {
  const color = isDeclined ? colors.COLORS_RED_500 : variantStyles[statusToVariant[status]].text

  return (
    <Typography variant="body2" title={label} css={[tw`mt-0.5 truncate min-w-0`, { color }]}>
      {label}
    </Typography>
  )
}

export const ContractorStepDetailsStatusLabel = memo(ContractorStepDetailsStatusLabelComponent)
